import React from 'react';
import PageLayout from '../../components/common/PageLayout';
import Hero from '../../components/common/Hero';
import DropshipProductsPermissionsContainer from '../blocks/DropshipProductsPermissionsContainer';

function DropshipPageContainer(props) {
  const pageHero = <Hero title="Dropship" />;

  return (
    <PageLayout top={pageHero}>
      <DropshipProductsPermissionsContainer />
    </PageLayout>
  );
}

export default DropshipPageContainer;
